(function () {
  /* =====================  CONFIG  ===================== */
  const IS_DELIVERY_PAGE = /\/pages\/delivery-info(?:\/|$)/.test(location.pathname);
  const IS_CART_PAGE     = /\/cart(?:\/|$)/.test(location.pathname);
  const DEFAULT_ZONES_URL = 'https://cdn.shopify.com/s/files/1/0750/9282/0220/files/delivery_zones.json';
  const DELIVERY_DATES_URL = 'https://cdn.shopify.com/s/files/1/0750/9282/0220/files/delivery_dates.json';
  const CACHE_BUCKET_MS = 10 * 60 * 1000;  // let the browser cache within a 10-min window
  const FETCH_ATTEMPTS  = 3;
  const SS_ZONES = 'apc_zones_v1';
  const SS_DATES = 'apc_dates_v1';
  /* ==================================================== */

  const norm = s => (s || '').toString().trim().toLowerCase();
  const esc  = s => { const d = document.createElement('div'); d.innerText = s; return d.innerHTML; };
  const debounce = (fn, d = 120) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), d); }; };
  const sleep = ms => new Promise(r => setTimeout(r, ms));

  /* ---------------------------------------------------------------------------
     CANONICALISATION  (2026-07-29)
     The checker used to compare the typed suburb to delivery_zones.json with exact
     string equality. Verified live, that rejected real customers: "Norwood SA",
     "Mt Barker", "Victor Harbour", "Saint Peters", "Adelaide CBD", "Westlakes",
     "Pt Adelaide", "OHalloran Hill" and anything with a double space were all told
     "Sorry, we don't deliver to you yet" — for suburbs on daily runs.

     canon() folds the common ways Australians write a suburb into one form:
     strips accents/punctuation, drops a trailing state or postcode, and expands the
     standard abbreviations. squash() additionally removes spaces so "Westlakes"
     reaches "West Lakes". Matching is still only ever AGAINST the known zone list,
     so fuzziness can never invent coverage that doesn't exist.
  --------------------------------------------------------------------------- */
  function canon(s) {
    return (s || '').toString().toLowerCase()
      .normalize('NFKD').replace(/[̀-ͯ]/g, '')   // accents
      .replace(/[‘’'`.]/g, '')                    // apostrophes / full stops
      // 2026-09-20: was a fixed list [-_/,], so the ';' in "ALDGATE;SA5154" survived
      // and broke the match. Treat anything that is not a letter, digit or space as a separator.
      .replace(/[^a-z0-9 ]/g, ' ')
      // 2026-09-20: was \b\d{4}\b, which missed "5046Warradale" (no word boundary between
      // digits and letters). Strip any 4-digit run wherever it sits.
      .replace(/\d{4}/g, ' ')                               // postcode
      .replace(/\bsouth australia\b/g, ' ')
      .replace(/\bs\s*a\b/g, ' ')                           // "SA" / "S A"
      .replace(/\bcbd\b/g, ' ')
      .replace(/\bmt\b/g, 'mount')
      .replace(/\bst\b/g, 'saint')
      .replace(/\bpt\b/g, 'port')
      .replace(/\bnth\b/g, 'north')
      .replace(/\bsth\b/g, 'south')
      .replace(/harbour/g, 'harbor')                        // Victor Harbor is the official spelling
      .replace(/\s+/g, ' ')
      .trim();
  }
  const squash = s => canon(s).replace(/\s+/g, '');

  // Damerau-Levenshtein (optimal string alignment), bailed out early — only ever used on
  // short suburb strings. 2026-09-20: this was plain Levenshtein, which scores a swapped
  // pair of letters as TWO edits. Under the 1-edit budget for names below 8 characters
  // that turned away real customers: "galwer" (Gawler) was refused in GA4, and the same
  // trap catches brighotn, nowrood, sterling-for-stirling. A transposition is one slip of
  // the fingers, so it now costs 1. Auto-accept still requires a SINGLE best candidate.
  function editDistance(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 99;
    const m = a.length, n = b.length;
    const d = [];
    for (let i = 0; i <= m; i++) { d[i] = new Array(n + 1).fill(0); d[i][0] = i; }
    for (let j = 0; j <= n; j++) d[0][j] = j;
    for (let i = 1; i <= m; i++) {
      for (let j = 1; j <= n; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);   // transposition
        }
      }
    }
    return d[m][n];
  }

  function openCartDrawer() {
    const trigger = document.querySelector('.js-drawer-open-cart, [data-drawer="CartDrawer"], [aria-controls="CartDrawer"]');
    if (trigger) { trigger.click(); return true; }
    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.classList.add('drawer--is-open');
      document.documentElement.classList.add('js-drawer-open', 'js-drawer-open-cart');
      try { drawer.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true })); } catch(_) {}
      return true;
    }
    return false;
  }

  function scrollDrawerToDeliveryFields() {
    setTimeout(function() {
      const drawer = document.getElementById('CartDrawer');
      if (!drawer) return;
      const scroller = drawer.querySelector('.drawer__inner[data-drawer-scroll]');
      const target   = drawer.querySelector('#step-area, #delivery-controls-drawer, #delivery-checker-anchor-cart');
      if (scroller && target) {
        const top = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 12;
        scroller.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }, 380);
  }

  function bindCartPageCheckoutBtn() {
    if (!IS_CART_PAGE) return;
    const btn = document.getElementById('apc-cart-page-checkout-btn');
    if (!btn || btn._apcBound) return;
    btn._apcBound = true;
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
      scrollDrawerToDeliveryFields();
    });
  }

  function revealCartPageFlowIfPresent() {
    if (!IS_CART_PAGE) return;
    try { document.dispatchEvent(new CustomEvent('pc:area-ok')); } catch(_) {}
  }

  /* ---------------------------------------------------------------------------
     RESILIENT LOADING  (2026-07-29)
     Previously: one fetch, cache:'no-store' + Date.now() cache-buster on every page
     load, and the promise was memoised even on failure — so a single network blip
     permanently broke the checker for that page view. Worse, a failed load left
     zonesData null, search() found nothing, and the shopper was shown
     "Sorry, we don't deliver to you yet" — a network error disguised as a refusal.

     Now: 3 attempts with backoff, a sessionStorage fallback so a blip serves the
     last-known-good list, the failed promise is cleared so a retry can succeed, and
     a load failure raises a DISTINCT "couldn't check right now" state with a Retry
     button. It never again claims we don't deliver somewhere because of a 500.
  --------------------------------------------------------------------------- */
  function cacheBust(url) {
    const bucket = Math.floor(Date.now() / CACHE_BUCKET_MS);
    return url + (url.includes('?') ? '&' : '?') + 'v=' + bucket;
  }

  /* ---------------------------------------------------------------------------
     REMEMBERED SUBURB  (2026-09-20)
     The suburb step sheds ~59% of everyone who opens the cart drawer, and a
     returning shopper had to retype it every single visit. We now remember the
     LAST CONFIRMED suburb (localStorage, 90 days) and, for logged-in customers,
     fall back to their default address suburb exposed by theme.liquid. On mount
     the input is pre-filled and the check runs itself, so the shopper confirms
     instead of typing. It is only ever a pre-fill: the field stays editable, the
     result names the matched suburb, and editing clears the memory.
  --------------------------------------------------------------------------- */
  /* ---------------------------------------------------------------------------
     POSTCODES  (2026-09-26)
     cart_postcode_typed showed ~5 shoppers a day typing four digits and being told
     "please enter a suburb name rather than a postcode". Only 56% of them recovered:
     44% left at that message. A postcode is four taps on a phone; a suburb name is not.

     PC_MAP is postcode -> [ ...suburbs we deliver to in that postcode, nUncovered ].
     The trailing number appears only when the postcode ALSO contains suburbs we do
     not deliver to — that is the case where we must ask which suburb they are in
     rather than assuming. Built from the Australia Post derived SA locality list
     (matthewproctor/australianpostcodes) filtered to suburbs present in
     delivery_zones.json, by scratchpad/build_postcode_map.py. Regenerate it whenever
     zones change; a suburb missing from here simply falls back to typing the name.
     2026-10-09: 5461 hand-added for Balaklava (joined CLARE / KADINA); 12 = the
     other 5461 localities, none delivered.
  --------------------------------------------------------------------------- */
  const PC_MAP = {"5000":["Adelaide","Rundle Mall","Halifax Street","Station Arcade","City West Campus",3],"5006":["North Adelaide","North Adelaide Melbourne St"],"5007":["Hindmarsh","Bowden","Welland","Brompton","West Hindmarsh"],"5008":["Croydon","Ridleyton","Devon Park","Dudley Park","Renown Park","Croydon Park","West Croydon",1],"5009":["Beverley","Kilkenny","Allenby Gardens"],"5010":["Angle Park","Regency Park","Ferryden Park",1],"5011":["Woodville","St Clair","Woodville Park","Woodville West","Woodville South",1],"5012":["Athol Park","Mansfield Park","Woodville North","Woodville Gardens"],"5013":["Gillman","Ottoway","Rosewater","Wingfield","Pennington","Rosewater East"],"5014":["Hendon","Alberton","Cheltenham","Queenstown","Royal Park","Albert Park"],"5015":["Torrens Island","Ethelton","New Port","Glanville","Birkenhead","Garden Island","Port Adelaide",2],"5016":["Largs Bay","Peterhead","Largs North"],"5017":["Osborne","Taperoo"],"5018":["North Haven","Outer Harbor"],"5019":["Exeter","Semaphore","Semaphore Park","Semaphore South"],"5020":["West Lakes Shore"],"5021":["West Lakes"],"5022":["Grange","Tennyson","Henley Beach","Henley Beach South",1],"5023":["Seaton","Findon",1],"5024":["West Beach","Fulham","Fulham Gardens"],"5025":["Flinders Park","Kidman Park"],"5031":["Mile End","Thebarton","Torrensville","Mile End South","Torrensville Plaza"],"5032":["Lockleys","Underdale","Brooklyn Park"],"5033":["Richmond","Hilton","Marleston","Cowandilla","Hilton Plaza","Marleston DC","West Richmond"],"5034":["Goodwood","Wayville","Millswood","Kings Park","Clarence Park"],"5035":["Ashford","Keswick","Forestville","Black Forest","Everard Park","Keswick Terminal"],"5037":["Netley","Glandore","Kurralta Park","North Plympton"],"5038":["Plympton","Camden Park","Plympton Park","South Plympton"],"5039":["Edwardstown","Melrose Park","Melrose Park DC","Clarence Gardens"],"5040":["Novar Gardens"],"5041":["Panorama","Daw Park","Cumberland Park","Westbourne Park","Colonel Light Gardens"],"5042":["Tonsley","Pasadena","St Marys","Bedford Park","Clovelly Park","Flinders University"],"5043":["Morphettville","Marion","Ascot Park","Park Holme","Mitchell Park"],"5044":["Glengowrie","Somerton Park"],"5045":["Glenelg","Glenelg East","Glenelg North","Glenelg South",1],"5046":["Warradale","Oaklands Park","Warradale North"],"5047":["Sturt","Darlington","Seacombe Gardens","Seacombe Heights"],"5048":["Hove","Brighton","Dover Gardens","North Brighton","South Brighton"],"5049":["Marino","Seacliff","Kingston Park","Seacliff Park","Seaview Downs"],"5050":["Bellevue Heights","Eden Hills"],"5051":["Coromandel Valley","Blackwood","Hawthorndene","Craigburn Farm"],"5052":["Belair","Glenalta"],"5061":["Unley","Malvern","Hyde Park","Unley Park",2],"5062":["Mitcham","Lynton","Clapham","Hawthorn","Netherby","Kingswood","Springfield","Torrens Park","Lower Mitcham","Brown Hill Creek","Mitcham Shopping Centre"],"5063":["Eastwood","Highgate","Parkside","Frewville","Fullarton"],"5064":["Urrbrae","Glenunga","Glen Osmond","Myrtle Bank","Mount Osmond","St Georges"],"5065":["Toorak Gardens","Dulwich","Tusmore","Glenside","Linden Park"],"5066":["Beaumont","Burnside","Erindale","Stonyfell","Wattle Park","Hazelwood Park","Waterfall Gully"],"5067":["Norwood","Kent Town","Rose Park","Beulah Park","Norwood South"],"5068":["Leabrook","Heathpool","Kensington","Marryatville","St Morris","Kensington Park","Trinity Gardens","Kensington Gardens"],"5069":["St Peters","Hackney","Stepney","Evandale","Maylands","College Park"],"5070":["Firle","Glynde","Joslin","Marden","Payneham","Felixstow","Glynde Plaza","Royston Park","Payneham South",1],"5072":["Skye","Magill","Auldana","Teringie","Woodforde","Magill North","Rosslyn Park",1],"5073":["Rostrevor","Tranmere","Hectorville","Tranmere North"],"5074":["Newton","Campbelltown"],"5075":["Paradise","Dernancourt"],"5076":["Athelstone","Castambul"],"5081":["Walkerville","Medindie","Gilberton","Vale Park","Collinswood","Medindie Gardens"],"5082":["Fitzroy","Ovingham","Prospect","Thorngate","Prospect East",1],"5083":["Broadview","Nailsworth","Sefton Park"],"5084":["Kilburn","Blair Athol","Kilburn North",1],"5085":["Northgate","Enfield","Clearview","Lightsview","Northfield","Enfield Plaza"],"5086":["Oakden","Hillcrest","Greenacres","Manningham","Gilles Plains","Hampstead Gardens"],"5087":["Windsor Gardens","Klemzig"],"5088":["Holden Hill"],"5089":["Highbury"],"5090":["Hope Valley"],"5091":["Vista","Banksia Park","Tea Tree Gully"],"5092":["Modbury Heights","Modbury","Modbury North",1],"5093":["Para Vista","Valley View"],"5094":["Cavan","Dry Creek","Gepps Cross"],"5095":["Pooraka","Mawson Lakes",1],"5096":["Para Hills","Para Hills West","Gulfview Heights"],"5097":["St Agnes","Ridgehaven","Redwood Park"],"5098":["Ingle Farm","Walkley Heights"],"5106":["Parafield","Salisbury South","Salisbury South DC",2],"5107":["Green Fields","Parafield Gardens"],"5108":["Salisbury North","Salisbury","Paralowie","Salisbury Downs","Salisbury North Whites Road"],"5109":["Salisbury East","Brahma Lodge","Salisbury Park","Salisbury Plain","Salisbury Heights","Salisbury East Northbri Ave"],"5110":["Direk","Burton","Bolivar","St Kilda","Waterloo Corner","Globe Derby Park"],"5111":["Edinburgh","Edinburgh RAAF"],"5112":["Elizabeth East","Elizabeth","Hillbank","Elizabeth Vale","Elizabeth Grove","Elizabeth South"],"5113":["Davoren Park","Elizabeth Park","Edinburgh North","Elizabeth Downs","Elizabeth North","Davoren Park South",3],"5114":["Uleybury","Blakeview","Craigmore","Smithfield","Yattalunga","Gould Creek","Andrews Farm","Humbug Scrub","Sampson Flat","One Tree Hill","Smithfield Plains",1],"5115":["Kudla","Munno Para","Munno Para West","Munno Para Downs"],"5116":["Hillier","Evanston","Evanston Park","Evanston South","Evanston Gardens"],"5117":["Angle Vale"],"5118":["Reid","Gawler","Hewett","Kalbeeba","Bibaringa","Buchfelde","Concordia","Kingsford","Ward Belt","Willaston","Gawler Belt","Gawler East","Gawler West","Gawler South","Kangaroo Flat",1],"5120":["Virginia","Buckland Park","Riverlea Park"],"5121":["Eyre","Penfield","Macdonald Park","Penfield Gardens"],"5125":["Greenwith","Golden Grove","Golden Grove Village"],"5126":["Yatala Vale","Surrey Downs","Fairview Park"],"5127":["Wynn Vale"],"5131":["Houghton","Lower Hermitage","Upper Hermitage"],"5132":["Paracombe"],"5133":["Inglewood"],"5134":["Montacute","Cherryville"],"5136":["Norton Summit"],"5137":["Ashton","Marble Hill"],"5138":["Basket Range"],"5139":["Forest Range"],"5140":["Greenhill"],"5141":["Summertown","Horsnell Gully"],"5142":["Uraidla"],"5144":["Carey Gully"],"5150":["Leawood Gardens",1],"5151":["Piccadilly"],"5152":["Cleland","Crafers","Stirling","Crafers West",1],"5153":["Mylor","Echunga","Flaxley","Bradbury","Ironbank","Longwood","Biggs Flat","Heathfield","Chapel Hill","Scott Creek","Macclesfield","Jupiter Creek","Green Hills Range"],"5154":["Aldgate"],"5155":["Bridgewater","Mount George"],"5156":["Upper Sturt"],"5157":["Ashbourne","Clarendon","Bull Creek","Kangarilla","Dorset Vale","McHarg Creek","Cherry Gardens","Coromandel East"],"5158":["Trott Park","Hallett Cove","Sheidow Park","O'Halloran Hill","O'Halloran Hill",1],"5159":["Happy Valley","Aberfoyle Park","Chandlers Hill","Flagstaff Hill"],"5160":["Lonsdale","Lonsdale DC",1],"5161":["Reynella","Old Reynella","Reynella East"],"5162":["Woodcroft","Morphett Vale"],"5163":["Hackham","Hackham West","Huntfield Heights","Onkaparinga Hills","Onkaparinga Heights"],"5164":["Christie Downs"],"5165":["Christies Beach","Christies Beach North"],"5166":["O'Sullivan Beach","O'Sullivan Beach"],"5167":["Port Noarlunga","Port Noarlunga South"],"5168":["Old Noarlunga","Noarlunga Downs","Noarlunga Centre"],"5169":["Seaford","Seaford Rise","Moana","Seaford Heights","Seaford Meadows"],"5170":["Maslin Beach"],"5171":["McLaren Vale","Tatachilla","McLaren Flat","Blewitt Springs",1],"5172":["Yundi","Kuitpo","Kyeema","Montarra","Willunga","The Range","Pages Flat","Hope Forest","Dingabledinga","Kuitpo Colony","Whites Valley","Willunga Hill","Willunga South"],"5173":["Aldinga","Aldinga Beach","Port Willunga",1],"5174":["Sellicks Hill","Sellicks Beach"],"5201":["Kuitpo","Meadows","Paris Creek","Prospect Hill","Blackfellows Creek"],"5202":["Myponga","Myponga Beach","Hindmarsh Tiers"],"5203":["Yankalilla","Parawa","Bald Hills","Tunkalilla","Wattle Flat","Torrens Vale"],"5204":["Delamere","Hay Flat","Rapid Bay","Silverton","Deep Creek","Cape Jervis","Normanville","Wirrina Cove","Carrickalinga","Second Valley"],"5210":["Nangkita","Mount Compass","Mount Magnificent"],"5211":["Chiton","McCracken","Waitpinga","Hayborough","Back Valley","Inman Valley","Mount Jagged","Willow Creek","Encounter Bay","Victor Harbor","Hindmarsh Valley","Lower Inman Valley","Victor Harbor Central",1],"5212":["Port Elliot"],"5213":["Middleton"],"5214":["Goolwa","Goolwa Beach","Goolwa North","Goolwa South","Mosquito Hill","Currency Creek","Hindmarsh Island",1],"5231":["Kersbrook","Millbrook","Chain Of Ponds"],"5232":["Cudlee Creek"],"5233":["Forreston","Gumeracha","Kenton Valley",1],"5234":["Birdwood"],"5235":["Cromer","Taunton","Springton","Eden Valley","Flaxman Valley","Mount Pleasant"],"5236":["Tungkillo"],"5238":["Woodlane",32],"5240":["Lenswood"],"5241":["Lobethal"],"5242":["Balhannah"],"5243":["Oakbank"],"5244":["Woodside","Harrogate","Charleston","Mount Torrens",1],"5245":["Verdun","Hahndorf","Paechtown"],"5250":["Totness","Blakiston","Littlehampton"],"5251":["Mount Barker","Wistow","Bugle Ranges","Mount Barker Summit","Mount Barker Springs","Mount Barker Junction"],"5252":["Nairne","Petwood","Brukunga","Dawesley","Kanmantoo","Hay Valley","St Ives"],"5253":["Murray Bridge","Brinkley","Mobilong","Monteith","Swanport","Long Flat","Riverglen","Avoca Dell","White Hill","Riverglades","Rocky Gully","Gifford Hill","Northern Heights","Murray Bridge East","Murray Bridge North","Murray Bridge South",10],"5254":["Murray Bridge","Tepko","Caloote","Monarto","Petwood","Monteith","Woodlane","Mypolonga","Pallamana","Rockleigh","Wall Flat","Callington","White Hill","Rocky Gully","Monarto South","Zadows Landing",2],"5255":["Salem","Hartley","Gemmells","Belvidere","Bletchley","Red Creek","Tooperang","Willyaroo","Strathalbyn","Woodchester","Highland Valley","Mount Observation",7],"5320":["Eba","Morgan","Murbko","Beaumonts","Brenda Park","Wombats Rest","Morphetts Flat","North West Bend",6],"5321":["Cadell","Cadell Lagoon"],"5322":["Ramco","Qualco","Sunlands","Ramco Heights","Golden Heights"],"5330":["Waikerie","Holder","Lowbank","Pooginook","Taylorville","Wigley Flat","Devlins Pound","Overland Corner","Stockyard Plain","Good Hope Landing",7],"5332":["Moorook","Moorook South",2],"5333":["Loxton","Pyap","Bookpurnong","Loxton North","New Residence",5],"5341":["Renmark","Chaffey","Cooltong","Crescent","Old Calperum","Renmark West","Renmark North","Renmark South",4],"5342":["Monash"],"5343":["Berri","Gerard","Winkie","Gurra Gurra",2],"5344":["Glossop"],"5345":["Barmera","Loveday","Spectacle Lake"],"5346":["Cobdogla"],"5350":["Rosedale","Sandy Creek"],"5351":["Lyndoch","Altona","Pewsey Vale","Williamstown","Mount Crawford","Cockatoo Valley","Barossa Goldfields"],"5352":["Tanunda","Bethany","Gomersal","Krondorf","Vine Vale","Stone Well","Rowland Flat"],"5353":["Moculta","Penrice","Angaston","Keyneton","Mount McKenzie",8],"5355":["Nuriootpa","Moppa","Ebenezer","Daveyston","Marananga","Stockwell","Light Pass","Seppeltsfield"],"5357":["Paisley","Blanchetown","Wigley Flat",4],"5360":["Nain","Greenock"],"5371":["Templers","Morn Hill","Roseworthy","Shea-Oak Log"],"5372":["Freeling"],"5373":["Fords","Bethel","Kapunda","Hamilton","Koonunga","Bagot Well","St Johns","Allendale North"],"5400":["Magdala","Wasleys","Woolsheds","Pinkerton Plains"],"5411":["Tarlee","Giles Corner"],"5412":["Rhynie","Riverton","Woolshed Flat",1],"5413":["Saddleworth",8],"5451":["Auburn","Undalya"],"5452":["Watervale","Leasingham"],"5453":["Clare","Armagh","Sevenhill","Gillentown","Penwortham","Stanley Flat",10],"5461":["Balaklava",12],"5464":["Anama","Bungaree","Condowie","Rochester","Brinkworth",3],"5501":["Avon","Dublin","Parham","Calomba","Windsor","Lewiston","Two Wells","Webb Beach","Long Plains","Lower Light","Port Gawler","Middle Beach","Thompson Beach","Wild Horse Plains"],"5502":["Fischer","Korunye","Mallala","Redbanks","Grace Plains","Reeves Plains"],"5510":["Lochiel"],"5520":["Snowtown","Barunga Gap",4],"5550":["Inkerman","Port Wakefield",6],"5552":["Port Arthur","Paskeville",5],"5554":["Kadina","Jericho","Cunliffe","New Town","Jerusalem","Matta Flat","Willamulka","Boors Plain","Wallaroo Mines",2],"5555":["Dowlingville",10],"5556":["Wallaroo","Warburto","North Beach",1],"5558":["Agery","Yelta","Hamley","Moonta","Kooroona","Nalyappa","Paramatta","Moonta Bay","Cross Roads","East Moonta","North Yelta","Port Hughes","Moonta Mines","North Moonta"],"5570":["Price","Clinton",3],"5571":["Ardrossan","Cunningham","Petersville","Dowlingville","Tiddy Widdy Beach",5],"5572":["Port Arthur",1],"5573":["Urania","Balgowan","Maitland","Point Pearce","Yorke Valley","Port Victoria","Chinamen Wells","South Kilkerran",3],"5950":["Adelaide Airport","Export Park"]};

  function postcodeEntry(pc) {
    const v = PC_MAP[pc];
    if (!v) return null;
    const subs = v.filter(x => typeof x === 'string');
    const uncovered = v.find(x => typeof x === 'number') || 0;
    return { subs, uncovered };
  }

  const LS_SUBURB = 'apc_suburb_v1';
  const SUBURB_TTL_MS = 90 * 24 * 60 * 60 * 1000;

  function rememberSuburb(name) {
    try { localStorage.setItem(LS_SUBURB, JSON.stringify({ s: name, t: Date.now() })); } catch (_) {}
  }
  function forgetSuburb() {
    try { localStorage.removeItem(LS_SUBURB); } catch (_) {}
  }
  function recalledSuburb() {
    try {
      const v = JSON.parse(localStorage.getItem(LS_SUBURB) || 'null');
      if (v && v.s && (Date.now() - (v.t || 0)) < SUBURB_TTL_MS) return v.s;
    } catch (_) {}
    return null;
  }
  // Set by theme.liquid for logged-in customers; never present for guests.
  function customerSuburb() {
    const v = window.__apcCustomerSuburb;
    return (typeof v === 'string' && v.trim()) ? v.trim() : null;
  }

  function ssGet(key) {
    try { const v = sessionStorage.getItem(key); return v ? JSON.parse(v) : null; } catch(_) { return null; }
  }
  function ssSet(key, val) {
    try { sessionStorage.setItem(key, JSON.stringify(val)); } catch(_) {}
  }

  async function fetchJsonResilient(url, ssKey) {
    let lastErr = null;
    for (let attempt = 1; attempt <= FETCH_ATTEMPTS; attempt++) {
      try {
        const r = await fetch(cacheBust(url), { cache: 'default' });
        if (!r.ok) throw new Error('HTTP ' + r.status);
        const data = await r.json();
        ssSet(ssKey, data);
        return { data, stale: false };
      } catch (e) {
        lastErr = e;
        if (attempt < FETCH_ATTEMPTS) await sleep(attempt * 400);
      }
    }
    const cached = ssGet(ssKey);
    if (cached) {
      console.warn('[delivery-checker] using cached copy after load failure', lastErr);
      return { data: cached, stale: true };
    }
    throw lastErr || new Error('load failed');
  }

  let zonesData = null, suburbsRaw = [], canonIndex = null, squashIndex = null, loadP = null;

  function currentZonesUrl() {
    return (
      document.getElementById('delivery-checker-root')?.dataset?.zonesUrl ||
      document.getElementById('delivery-checker-root-cart')?.dataset?.zonesUrl ||
      DEFAULT_ZONES_URL
    );
  }

  function buildIndexes(data) {
    zonesData = data || {};
    const seen = new Set();
    suburbsRaw = [];
    canonIndex = new Map();
    squashIndex = new Map();
    Object.entries(zonesData).forEach(([area, z]) => (z.suburbs || []).forEach(s => {
      const n = norm(s);
      if (!seen.has(n)) { seen.add(n); suburbsRaw.push(s); }
      const c = canon(s), q = squash(s);
      if (!canonIndex.has(c)) canonIndex.set(c, []);
      canonIndex.get(c).push({ raw: s, area });
      if (!squashIndex.has(q)) squashIndex.set(q, []);
      squashIndex.get(q).push({ raw: s, area });
    }));
  }

  function loadZones() {
    if (zonesData) return Promise.resolve(zonesData);
    if (!loadP) {
      loadP = fetchJsonResilient(currentZonesUrl(), SS_ZONES)
        .then(({ data }) => { buildIndexes(data); return zonesData; })
        .catch(e => {
          loadP = null;                       // allow a later retry to succeed
          console.error('[delivery-checker] zones load failed', e);
          throw e;                            // callers must distinguish this from "no match"
        });
    }
    return loadP;
  }

  let deliveryDates = null, deliveryDatesP = null;

  function loadDeliveryDates() {
    if (deliveryDates) return Promise.resolve(deliveryDates);
    if (!deliveryDatesP) {
      deliveryDatesP = fetchJsonResilient(DELIVERY_DATES_URL, SS_DATES)
        .then(({ data }) => { deliveryDates = data || {}; return deliveryDates; })
        .catch(e => {
          deliveryDatesP = null;
          console.warn('[delivery-checker] delivery dates load failed', e);
          return {};                          // non-fatal: fall back to all weekdays
        });
    }
    return deliveryDatesP;
  }

  function getAllowedDatesForSuburb(suburb) {
    if (!zonesData || !deliveryDates) return null;
    const matched = matchSuburb(suburb);
    if (!matched.hits.length) return null;
    // union of every matched zone's dates (a suburb can sit in more than one zone)
    const out = new Set();
    matched.hits.forEach(h => (deliveryDates[h.area] || []).forEach(d => out.add(d)));
    return out.size ? Array.from(out).sort() : null;
  }

  window.__apcGetAllowedDates = function(suburb) { return getAllowedDatesForSuburb(suburb); };
  window.__apcLoadDeliveryDates = loadDeliveryDates;

  /* Returns {hits:[{raw,area}], suggestions:[raw], exact:bool}. Never invents coverage. */
  function matchSuburb(qRaw) {
    const c = canon(qRaw), q = squash(qRaw);
    if (!c) return { hits: [], suggestions: [], exact: false };
    if (canonIndex && canonIndex.has(c)) return { hits: canonIndex.get(c), suggestions: [], exact: true };
    if (squashIndex && squashIndex.has(q)) return { hits: squashIndex.get(q), suggestions: [], exact: true };
    // near-miss: a typo. Auto-accept only when exactly one candidate is within 1 edit.
    const near = [];
    if (canonIndex) {
      for (const [key, entries] of canonIndex) {
        const d = editDistance(c, key);
        if (d <= (c.length >= 8 ? 2 : 1)) near.push({ key, entries, d });
      }
    }
    near.sort((a, b) => a.d - b.d);
    const best = near.filter(n => n.d === near[0]?.d);
    if (best.length === 1) return { hits: best[0].entries, suggestions: [], exact: false };

    /* 2026-09-20 fallbacks, added after replaying 60 days of cart_suburb_miss events
       (real shoppers in Bellevue Heights, Mount Barker, Warradale, Aldgate and Kidman
       Park were told we don't deliver). Each one can only ever resolve TO a suburb
       already in the zone list, so none of them can invent coverage. */
    // (a) trailing city/state words: "Bellevue Heights Adelaide" -> "Bellevue Heights".
    //     Only retried when something is left, so plain "Adelaide" still matches.
    if (!matchDepth) {
      const trimmed = c.replace(/\s+(adelaide|australia|aus)$/, '').trim();
      if (trimmed && trimmed !== c) {
        matchDepth = 1;
        try {
          const r = matchSuburb(trimmed);
          if (r.hits.length) return r;
        } finally { matchDepth = 0; }
      }
    }
    // (b) trailing suburb in a pasted street address: "26 Turnberry Crescent Mount barker".
    //     The suburb must SIT AT THE END. An earlier version matched the suburb anywhere in
    //     the string and it invented coverage from street names: "26 Turnberry Crescent
    //     Mount Gambier" answered "Yes, we deliver to Crescent" (a real Riverland suburb)
    //     and "9 Mitcham Road Woop Woop" answered "Yes, we deliver to Mitcham". Addresses
    //     end with the suburb, and canon() has already removed a trailing state/postcode,
    //     so an end-anchored match is both safe and sufficient. Longest suffix wins, so
    //     "North Adelaide" beats "Adelaide".
    if (canonIndex && c.indexOf(' ') > -1) {
      let bestKey = '';
      for (const key of canonIndex.keys()) {
        if (key.length < 5 || key.length <= bestKey.length) continue;
        if (c === key || c.endsWith(' ' + key)) bestKey = key;
      }
      if (bestKey) return { hits: canonIndex.get(bestKey), suggestions: [], exact: false };
    }
    // (c) prefix: "Kidman" -> Kidman Park. One candidate is accepted, several are offered.
    if (canonIndex && c.length >= 3) {
      const pre = [];
      for (const [key, entries] of canonIndex) if (key.startsWith(c + ' ')) pre.push({ key, entries });
      if (pre.length === 1) return { hits: pre[0].entries, suggestions: [], exact: false };
      if (pre.length > 1 && !near.length)
        return { hits: [], suggestions: pre.slice(0, 5).map(p => p.entries[0].raw), exact: false };
    }
    // (d) 2026-10-04: a known suburb at the START with extra words after it - "Torrens Park
    //     by" was refused on 29 Sep (GA4 cart_suburb_miss). OFFERED as a "Did you mean" chip,
    //     never auto-accepted: a leading match can be a street name ("Mitcham Road Woop
    //     Woop"), so the shopper confirms with one tap rather than us assuming coverage.
    //     A numbered street address can't reach this - it starts with the house number.
    if (canonIndex && c.indexOf(' ') > -1) {
      let lead = '';
      for (const key of canonIndex.keys()) {
        if (key.length < 5 || key.length <= lead.length) continue;
        if (c.startsWith(key + ' ')) lead = key;
      }
      if (lead) {
        const s = canonIndex.get(lead)[0].raw;
        const rest = near.map(n => n.entries[0].raw).filter(x => x !== s);
        return { hits: [], suggestions: [s].concat(rest).slice(0, 5), exact: false };
      }
    }
    return { hits: [], suggestions: near.slice(0, 5).map(n => n.entries[0].raw), exact: false };
  }
  let matchDepth = 0;

  /* Groups matched zones into the human summary shown to the shopper. */
  function summarise(hits) {
    const perArea = {};
    hits.forEach(h => {
      const z = zonesData[h.area] || {};
      const freq = (z.delivery_frequency || '').trim();
      const days = (z.delivery_days || '').trim();
      (perArea[h.area] = perArea[h.area] || []).push({ frequency: freq, days });
    });
    const results = [];
    Object.keys(perArea).forEach(area => {
      const groups = {};
      perArea[area].forEach(e => {
        if (!groups[e.frequency]) groups[e.frequency] = new Set();
        (e.days || '').split(/[,&+/]+/).map(s => s.trim())
          .filter(d => d && d.toLowerCase() !== 'nan')
          .forEach(d => groups[e.frequency].add(d));
      });
      const parts = Object.keys(groups).filter(Boolean).map(freq => {
        const days = Array.from(groups[freq]);
        return freq + (days.length ? ` (${days.join(' & ')})` : '');
      });
      const z = zonesData[area] || {};
      results.push({ area, summary: parts.join(' and '),
                     frequency: (z.delivery_frequency || '').trim(),
                     days: (z.delivery_days || '').trim() });
    });
    return results;
  }

  function initInstance(cfg) {
    if (!cfg.root || cfg.root._bound) return;
    cfg.root._bound = true;
    cfg.root.hidden = false;
    let hi = -1;
    const toggleHint = () => {
      if (!cfg.hintEl) return;
      const hasOut   = !!(cfg.out && cfg.out.textContent.trim());
      const hasValue = !!(cfg.input && cfg.input.value.trim());
      cfg.hintEl.style.display = (hasOut || hasValue) ? 'none' : '';
    };
    const show = html => { if (cfg.out) cfg.out.innerHTML = html || ''; toggleHint(); };
    function closeBox() {
      if (!cfg.suggestBox) return;
      cfg.suggestBox.classList.remove('visible');
      cfg.suggestBox.innerHTML = '';
      hi = -1;
      cfg.input?.setAttribute('aria-expanded', 'false');
    }
    function openBox(list) {
      if (!cfg.suggestBox) return;
      cfg.suggestBox.innerHTML = list.map((n, i) =>
        `<div class="pc-suggest-item" role="option" data-i="${i}" aria-selected="false">${esc(n)}</div>`).join('');
      cfg.suggestBox.classList.add('visible');
      cfg.input?.setAttribute('aria-expanded', 'true');
    }
    const renderSuggest = debounce(function() {
      const q = canon(cfg.input.value);
      if (q.length < 2) { closeBox(); return; }
      // Previously this returned silently while the zone list loaded, so the FIRST
      // thing a shopper typed produced no suggestions at all — they had to type again.
      // Re-run once the list is in.
      if (!zonesData) { loadZones().then(() => renderSuggest()).catch(()=>{}); return; }
      const starts = [], contains = [];
      for (let i = 0; i < suburbsRaw.length; i++) {
        const n = canon(suburbsRaw[i]);
        if (n.startsWith(q)) { if (starts.length < 8) starts.push(suburbsRaw[i]); }
        else if (n.includes(q)) { if (contains.length < 8) contains.push(suburbsRaw[i]); }
        if (starts.length >= 8 && contains.length >= 8) break;
      }
      const list = starts.concat(contains).slice(0, 8);
      list.length ? openBox(list) : closeBox();
    }, 100);
    function highlight(i) {
      if (!cfg.suggestBox) return;
      const items = cfg.suggestBox.querySelectorAll('.pc-suggest-item');
      items.forEach(el => el.setAttribute('aria-selected', 'false'));
      if (i >= 0 && i < items.length) {
        items[i].setAttribute('aria-selected', 'true');
        hi = i;
        const el = items[i], top = el.offsetTop, bot = top + el.offsetHeight;
        if (cfg.suggestBox.scrollTop > top) cfg.suggestBox.scrollTop = top;
        if (cfg.suggestBox.scrollTop + cfg.suggestBox.clientHeight < bot)
          cfg.suggestBox.scrollTop = bot - cfg.suggestBox.clientHeight;
      } else { hi = -1; }
    }
    // 2026-07-29: picking a suggestion used to only fill the box and stop, so the
    // shopper had to ALSO press "Check delivery". Verified live that many would see
    // nothing happen and give up. Picking now runs the check immediately.
    function pick(i) {
      const el = cfg.suggestBox?.querySelectorAll('.pc-suggest-item')[i];
      if (!el || !cfg.input) return;
      cfg.input.value = el.textContent;
      closeBox();
      run();
    }

    function renderFromData(q) {
      const matched = matchSuburb(q);
      if (!matched.hits.length) {
        if (matched.suggestions.length) {
          show(`We couldn’t find <strong>${esc(q)}</strong>. Did you mean: ` +
               matched.suggestions.map(s =>
                 `<button type="button" class="pc-didyoumean" data-suburb="${esc(s)}">${esc(s)}</button>`
               ).join(' ') + '?');
        } else {
          // 2026-07-31: this used to dead-end at a /pages/contact link, which threw away the
          // cart and the suburb they'd just typed. Now they can hand both to us in one step.
          // Out-of-zone is not necessarily a no - APC can often add a stop to an existing run.
          showOutOfArea(q);
        }
        return;
      }
      renderHit(matched, q);
    }

    /* The out-of-area capture, reused by the postcode path. */
    function showOutOfArea(q) {
          show(`Sorry, we don’t deliver to <strong>${esc(q)}</strong> yet — but we may be able to.` +
               `<div class="pc-notify" data-suburb="${esc(q)}">` +
                 `<p class="pc-notify__lead">Send us your cart and suburb and we’ll come back to you about a delivery run.</p>` +
                 `<input type="email" class="pc-notify__email" placeholder="your@email.com" autocomplete="email" inputmode="email">` +
                 `<input type="text" class="pc-notify__name" placeholder="Your name (optional)" autocomplete="name">` +
                 `<textarea class="pc-notify__msg" rows="2" placeholder="Anything else we should know? (optional)"></textarea>` +
                 `<button type="button" class="pc-notify__submit">Ask us about delivery</button>` +
                 `<p class="pc-notify__status" role="status"></p>` +
               `</div>`);
    }

    function renderHit(matched, q) {
      const zones = summarise(matched.hits);
      const items = Array.from(new Set(zones.map(z => z.summary).filter(Boolean)))
        .map(s => `<li>${esc(s)}</li>`).join('');
      // Always echo the CANONICAL suburb, not what was typed, so the shopper can see
      // which suburb we actually matched ("Mt Barker" -> "Mount Barker").
      const label = esc(matched.hits[0].raw);
      show(`Yes, we deliver to <strong>${label}</strong>:<ul>${items}</ul>` +
           (cfg._prefilled ? `<p class="pc-recalled">Saved from your last visit — change the suburb above if this isn’t right.</p>`
            : cfg._fromPostcode ? `<p class="pc-recalled">Matched from postcode ${esc(cfg._fromPostcode)} — change the suburb above if you’re in a different one.</p>`
            : ``));
      rememberSuburb(matched.hits[0].raw);
      revealCartPageFlowIfPresent();
      const seq = cfg._seq = (cfg._seq || 0) + 1;
      loadDeliveryDates().then(() => {
        const allowed = getAllowedDatesForSuburb(q);
        if (seq === cfg._seq) showNextDates(zones, allowed);
        try {
          document.dispatchEvent(new CustomEvent('pc:suburb-confirmed', {
            detail: { suburb: matched.hits[0].raw, allowedDates: allowed, zones: zones }
          }));
        } catch(_) {}
      });
    }
    /* 2026-11-03: "Monthly (Thursday)" didn't say WHICH Thursday. Append the next bookable
       run date (and the one after, for non-daily zones). Dates come from the cart drawer's
       apcFirstSelectable so lead time / holidays / weekends match the picker exactly; if the
       drawer isn't on the page or the zone has run dry, the line is simply omitted. Skipped
       inside the drawer itself, whose date note already says "Next available". */
    function showNextDates(zones, allowed) {
      const first = window.__apcFirstSelectable;
      if (typeof first !== 'function' || !cfg.out || cfg.out.closest('#CartDrawer')) return;
      const next = first(allowed);
      if (!next) return;
      const fmt = iso => {
        const [y, m, d] = iso.split('-').map(Number);
        return new Date(y, m - 1, d).toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
      };
      const daily = zones.some(z => /daily/i.test(z.frequency || ''));
      const after = !daily && allowed ? first(allowed.filter(d => d > next)) : null;
      cfg.out.insertAdjacentHTML('beforeend',
        `<p class="pc-next">Next delivery: <strong>${esc(fmt(next))}</strong>` +
        (after ? `, then ${esc(fmt(after))}` : '') + `</p>`);
    }
    cfg.root._renderFromData = (data, q) => renderFromData(q);

    /* Four digits: resolve to a suburb we deliver to, ask which one, or decline.
       Never guesses across zones — if the postcode spans more than one delivery zone,
       or contains suburbs we don't serve, the shopper picks from chips. */
    function runPostcode(pc) {
      show('Checking…');
      loadZones().then(() => {
        const entry = postcodeEntry(pc);
        if (!entry || !entry.subs.length) {
          try {
            document.dispatchEvent(new CustomEvent('pc:postcode-typed', {
              detail: { value: pc, outcome: 'miss' }
            }));
          } catch (_) {}
          showOutOfArea(pc);
          return;
        }
        // Which zones do those suburbs sit in? Same zone + nothing uncovered = safe to accept.
        const areas = new Set();
        entry.subs.forEach(name => {
          const m = matchSuburb(name);
          m.hits.forEach(h => areas.add(h.area));
        });
        const unambiguous = areas.size === 1 && !entry.uncovered;
        try {
          document.dispatchEvent(new CustomEvent('pc:postcode-typed', {
            detail: { value: pc, outcome: unambiguous ? 'zone' : 'chips' }
          }));
        } catch (_) {}
        if (unambiguous) {
          cfg._fromPostcode = pc;
          if (cfg.input) cfg.input.value = entry.subs[0];
          renderFromData(entry.subs[0]);
          cfg._fromPostcode = null;
          return;
        }
        show(`Postcode <strong>${esc(pc)}</strong> covers a few suburbs. Which one are you in? ` +
             entry.subs.slice(0, 8).map(sub =>
               `<button type="button" class="pc-didyoumean" data-suburb="${esc(sub)}">${esc(sub)}</button>`
             ).join(' ') +
             (entry.uncovered ? `<p class="pc-recalled">Not listed? We may not deliver to your part of ${esc(pc)} yet — type your suburb to check.</p>` : ``));
      }).catch(() => {
        show(`We couldn’t check delivery areas just now — that’s us, not you. ` +
             `<button type="button" class="pc-retry">Try again</button>`);
      });
    }

    function run(e) {
      if (e) { e.preventDefault?.(); e.stopPropagation?.(); }
      const q = (cfg.input?.value || '').trim();
      if (!q) { show('Please enter a suburb.'); return; }
      const digits = q.replace(/\s/g, '');
      if (/^\d{4}$/.test(digits)) { runPostcode(digits); return; }
      if (/^\d+$/.test(digits)) {
        show('Please enter a suburb name rather than a postcode — e.g. Norwood.');
        // 2026-09-20: this refusal returns BEFORE anything renders into the result box,
        // so the cart_suburb_miss observer in apc-step-tracking.liquid never saw it and
        // postcode attempts were invisible. They may be a real share of the step-1 drop
        // (a postcode is four taps on a phone keypad; a suburb name is not), so count
        // them. Not deduped: repetition is the signal. Postcode only, no other text.
        try {
          document.dispatchEvent(new CustomEvent('pc:postcode-typed', {
            detail: { value: q.replace(/\s/g, '').slice(0, 8) }
          }));
        } catch (_) {}
        return;
      }
      closeBox();
      show('Checking…');
      loadZones()
        .then(() => renderFromData(q))
        .catch(() => {
          // A load failure must NEVER read as "we don't deliver to you".
          show(`We couldn’t check delivery areas just now — that’s us, not you. ` +
               `<button type="button" class="pc-retry">Try again</button> ` +
               `or <a href="/pages/contact">contact us</a>.`);
        });
    }
    cfg.button?.addEventListener('click', run, { passive: false });
    cfg.input?.addEventListener('keydown', e => {
      if (e.key === 'Enter')      { run(e); return; }
      if (e.key === 'ArrowDown')  { e.preventDefault(); highlight(hi + 1); }
      if (e.key === 'ArrowUp')    { e.preventDefault(); highlight(Math.max(hi - 1, 0)); }
      if (e.key === 'Escape')     { closeBox(); }
    }, { passive: false });
    cfg.input?.addEventListener('input', renderSuggest);
    // Editing the field means the remembered suburb is no longer what they want.
    cfg.input?.addEventListener('input', () => { if (cfg._prefilled) { cfg._prefilled = false; forgetSuburb(); } });
    cfg.input?.addEventListener('focus', () => { loadZones().catch(()=>{}); });
    cfg.suggestBox?.addEventListener('click', e => {
      const el = e.target.closest('.pc-suggest-item'); if (el) pick(parseInt(el.dataset.i, 10));
    });
    // "Did you mean" chips and the retry button live inside the result area.
    cfg.out?.addEventListener('click', e => {
      const dym = e.target.closest('.pc-didyoumean');
      if (dym) { cfg.input.value = dym.dataset.suburb; run(); return; }
      if (e.target.closest('.pc-retry')) { loadP = null; run(); return; }
      if (e.target.closest('.pc-notify__submit')) { submitDeliveryRequest(e.target.closest('.pc-notify')); }
    });

    // Emails the out-of-area request to APC with the cart attached, via the same Render
    // endpoint the product-page contact tab already uses (apcautomations /contact ->
    // {name, email, message}). No new infrastructure, and it is already CORS-open to the
    // storefront. Deliberately does NOT subscribe anyone to marketing - this is a service
    // request, and silently adding them to a list would be a different thing than they asked for.
    async function submitDeliveryRequest(box) {
      if (!box || box._sending) return;
      const emailEl  = box.querySelector('.pc-notify__email');
      const nameEl   = box.querySelector('.pc-notify__name');
      const msgEl    = box.querySelector('.pc-notify__msg');
      const btn      = box.querySelector('.pc-notify__submit');
      const statusEl = box.querySelector('.pc-notify__status');
      const suburb   = box.dataset.suburb || '';
      const email    = (emailEl?.value || '').replace(/\s+/g, '');
      if (emailEl) emailEl.value = email;
      const chk = window.apcEmailCheck ? window.apcEmailCheck(email)
        : { ok: /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email), suggestion: null };

      if (!email || !chk.ok) {
        statusEl.textContent = 'Please enter a valid email address so we can reply.';
        statusEl.className = 'pc-notify__status pc-notify__status--err';
        emailEl?.focus();
        return;
      }
      // Likely domain typo (gmial.com, bigpond.con): offer the fix once, then send as typed.
      if (chk.suggestion && box._suggestedFor !== email) {
        box._suggestedFor = email;
        statusEl.innerHTML = 'Did you mean <button type="button" class="pc-notify__fixemail" ' +
          'style="background:none;border:0;padding:0;font:inherit;font-weight:600;text-decoration:underline;cursor:pointer;color:inherit;">' +
          esc(chk.suggestion) + '</button>? Tap it to fix, or press send again if yours is right.';
        statusEl.className = 'pc-notify__status pc-notify__status--err';
        const fix = statusEl.querySelector('.pc-notify__fixemail');
        fix?.addEventListener('click', ev => {
          ev.stopPropagation();
          if (emailEl) emailEl.value = chk.suggestion;
          statusEl.textContent = '';
          statusEl.className = 'pc-notify__status';
        });
        emailEl?.focus();
        return;
      }

      box._sending = true;
      btn.disabled = true;
      const originalLabel = btn.textContent;
      btn.textContent = 'Sending\u2026';
      statusEl.textContent = '';
      statusEl.className = 'pc-notify__status';

      let cartLines = 'Cart could not be read.';
      let cartTotal = '';
      try {
        const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        if (cart && cart.items && cart.items.length) {
          cartLines = cart.items.map(i =>
            `- ${i.product_title}${i.variant_title && i.variant_title !== 'Default Title' ? ' \u2014 ' + i.variant_title : ''}` +
            ` x${i.quantity} \u2014 $${((i.line_price || 0) / 100).toFixed(2)}`).join('\n');
          cartTotal = `\n\nCart total: $${((cart.total_price || 0) / 100).toFixed(2)} (${cart.item_count} item(s))`;
        } else {
          cartLines = '(cart was empty at the time of enquiry)';
        }
      } catch (_) {}

      const note = (msgEl?.value || '').trim();
      const body =
        `OUT-OF-AREA DELIVERY REQUEST (from the cart drawer)\n\n` +
        `Suburb entered: ${suburb}\n` +
        `This suburb is not currently in delivery_zones.json.\n\n` +
        (note ? `Customer note:\n${note}\n\n` : '') +
        `Cart contents:\n${cartLines}${cartTotal}\n\n` +
        `Reply to: ${email}`;

      try {
        const ctrl = new AbortController();
        const t = setTimeout(() => ctrl.abort(), 15000);
        const r = await fetch('https://apcautomations.onrender.com/contact', {
          method: 'POST', mode: 'cors', credentials: 'omit', signal: ctrl.signal,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: (nameEl?.value || '').trim() || `Delivery enquiry \u2014 ${suburb}`,
            email: email,
            message: body
          })
        });
        clearTimeout(t);
        const data = await r.json().catch(() => ({}));
        if (!r.ok || !data.success) throw new Error('send failed');
        box.innerHTML =
          `<p class="pc-notify__done"><strong>Thanks \u2014 that\u2019s with us.</strong> ` +
          `We\u2019ve got your cart and <strong>${esc(suburb)}</strong>, and we\u2019ll email you at ` +
          `${esc(email)} about getting a run to you.</p>`;
        try { window.__apcTrackDate && window.__apcTrackDate('cart_delivery_request', { suburb_query: suburb }); } catch (_) {}
      } catch (_) {
        box._sending = false;
        btn.disabled = false;
        btn.textContent = originalLabel;
        statusEl.innerHTML = 'Sorry, that didn\u2019t send. Please email ' +
          '<a href="mailto:enquiries@adelaideplantco.com.au">enquiries@adelaideplantco.com.au</a> ' +
          'and mention ' + esc(suburb) + '.';
        statusEl.className = 'pc-notify__status pc-notify__status--err';
      }
    }
    cfg.root.addEventListener('click', e => e.stopPropagation());
    show(cfg.out?.innerHTML || '');

    /* Pre-fill, then check for them. Never overwrites something already typed. */
    (function prefill() {
      if (!cfg.input || cfg.input.value.trim()) return;
      const recalled = recalledSuburb();
      const name = recalled || customerSuburb();
      if (!name) return;
      cfg.input.value = name;
      cfg._prefilled = true;
      try {
        document.dispatchEvent(new CustomEvent('pc:suburb-prefilled', {
          detail: { suburb: name, source: recalled ? 'storage' : 'customer' }
        }));
      } catch (_) {}
      // Run the real check so an out-of-date memory (or a suburb dropped from the
      // zone list) still shows the honest answer rather than a silent pass.
      run();
    })();
  }

  function bindIfNeededWithin(root) {
    if (!root || root._bound) return;
    initInstance({
      root,
      input:      root.querySelector('#pc-input')       || root.querySelector('#pc-input-cart'),
      button:     root.querySelector('#pc-check')       || root.querySelector('#pc-check-cart'),
      out:        root.querySelector('#pc-result')      || root.querySelector('#pc-result-cart'),
      suggestBox: root.querySelector('#pc-suggest')     || root.querySelector('#pc-suggest-cart'),
      hintEl:     root.querySelector('.pc-hint') || null
    });
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('#pc-check, #pc-check-cart');
    if (!btn) return;
    const root = btn.closest('#delivery-checker-root, #delivery-checker-root-cart');
    if (!root) return;
    if (!root._bound) {
      e.preventDefault();
      e.stopPropagation();
      bindIfNeededWithin(root);
      setTimeout(() => { try { btn.click(); } catch(_){} }, 0);
    }
  });

  (function injectPageStyles() {
    if (document.getElementById('pc-page-suggest-css')) return;
    const style = document.createElement('style');
    style.id = 'pc-page-suggest-css';
    style.textContent = `
      #pc-suggest, #pc-suggest-cart{ max-height: 240px; overflow:auto; border:1px solid #e2e2e2; border-radius:6px; margin-top:.25rem; background:#fff; }
      #pc-suggest:not(.visible), #pc-suggest-cart:not(.visible){ display:none; }
      .pc-suggest-item{ padding:.5rem .75rem; cursor:pointer; }
      .pc-suggest-item[aria-selected="true"]{ background:#f3f3f3; }
      #pc-result, #pc-result-cart { white-space: normal; }
      .pc-didyoumean, .pc-retry{ display:inline-block; margin:.15rem .2rem 0 0; padding:.3rem .55rem; font:inherit; font-size:13px;
        border:1px solid #4a5c3e; background:#fff; color:#4a5c3e; border-radius:5px; cursor:pointer; }
      .pc-didyoumean:hover, .pc-retry:hover{ background:#4a5c3e; color:#fff; }
      .pc-notify{ margin-top:.6rem; padding:.7rem .75rem; background:#f6f4ef; border:1px solid #ddd6c9; border-radius:8px; }
      .pc-notify__lead{ margin:0 0 .5rem; font-size:13px; line-height:1.45; color:#2f4836; }
      .pc-notify input, .pc-notify textarea{ width:100%; box-sizing:border-box; margin-bottom:.4rem; padding:.5rem .6rem;
        border:1px solid #ccc; border-radius:6px; font:inherit; font-size:16px; background:#fff; }
      .pc-notify textarea{ resize:vertical; }
      .pc-notify__submit{ width:100%; padding:.55rem; border:none; border-radius:6px; background:#2f4836; color:#fff;
        font:inherit; font-size:14px; font-weight:600; cursor:pointer; }
      .pc-notify__submit:hover:not([disabled]){ background:#3d5a47; }
      .pc-notify__submit[disabled]{ opacity:.65; cursor:default; }
      .pc-notify__status{ margin:.45rem 0 0; font-size:12.5px; line-height:1.4; }
      .pc-notify__status--err{ color:#a01c1c; }
      .pc-notify__done{ margin:0; font-size:13px; line-height:1.5; color:#2f4836; }
    `;
    document.head.appendChild(style);
  })();

  function initDeliveryInfoPageIfPresent() {
    if (!IS_DELIVERY_PAGE) return;
    const root = document.getElementById('delivery-checker-root');
    if (!root) return;
    initInstance({
      root,
      input:      document.getElementById('pc-input'),
      button:     document.getElementById('pc-check'),
      out:        document.getElementById('pc-result'),
      suggestBox: document.getElementById('pc-suggest'),
      hintEl:     root.parentElement?.querySelector('small') || null
    });
  }

  const PAGE_WIDGET_HTML = (zonesUrl) => `
    <div id="delivery-checker-root" class="delivery-checker" data-zones-url="${esc(zonesUrl)}">
      <label for="pc-input">ENTER YOUR SUBURB</label>
      <input id="pc-input" type="text" placeholder="e.g. Norwood" />
      <div id="pc-suggest" role="listbox" aria-label="Suburb suggestions"></div>
      <button id="pc-check" type="button">Check delivery</button>
      <div id="pc-result" aria-live="polite"></div>
    </div>
  `;

  let pageWidgetTimer = null;
  function ensureCartPageWidget() {
    if (IS_DELIVERY_PAGE) {
      function mountInto(anchor) {
        if (!anchor) return false;
        document.querySelectorAll('#delivery-checker-root').forEach(el => {
          if (!anchor.contains(el)) el.remove();
        });
        if (!anchor.querySelector('#delivery-checker-root')) {
          anchor.insertAdjacentHTML('beforeend', PAGE_WIDGET_HTML(currentZonesUrl()));
        }
        const root = anchor.querySelector('#delivery-checker-root');
        if (root && !root._bound) {
          initInstance({
            root,
            input:      root.querySelector('#pc-input'),
            button:     root.querySelector('#pc-check'),
            out:        root.querySelector('#pc-result'),
            suggestBox: root.querySelector('#pc-suggest'),
            hintEl:     anchor.querySelector('.pc-hint') || null
          });
        }
        document.querySelectorAll('#delivery-checker-anchor').forEach(el => el.remove());
        return true;
      }
      const okNow = mountInto(document.getElementById('delivery-checker-anchor-page'));
      if (okNow) return;
      if (!pageWidgetTimer) {
        let tries = 0;
        pageWidgetTimer = setInterval(() => {
          if (mountInto(document.getElementById('delivery-checker-anchor-page')) || ++tries > 80) {
            clearInterval(pageWidgetTimer); pageWidgetTimer = null;
          }
        }, 100);
      }
    }
  }

  const CART_HTML = (zonesUrl) => `
    <div class="delivery-checker" id="delivery-checker-root-cart" data-zones-url="${esc(zonesUrl)}">
      <label for="pc-input-cart">Enter your suburb</label>
      <input id="pc-input-cart" type="text" placeholder="e.g. Norwood" />
      <div id="pc-suggest-cart" class="pc-suggest" role="listbox"></div>
      <button id="pc-check-cart" type="button">Check delivery</button>
      <div id="pc-result-cart" aria-live="polite"></div>
    </div>
  `;

  let cartStyleInjected = false;
  let drawerRetryTimer = null;

  function ensureCartDrawerInstance() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    const form = drawer.querySelector('#CartDrawerForm');
    if (!form) return;
    const field = form.querySelector('#step-area') || form;
    if (!field) return;
    let anchor = field.querySelector('#delivery-checker-anchor-cart');
    if (!anchor) {
      anchor = document.createElement('div');
      anchor.id = 'delivery-checker-anchor-cart';
      field.appendChild(anchor);
    }
    if (!anchor.querySelector('#delivery-checker-root-cart')) {
      anchor.insertAdjacentHTML('beforeend', CART_HTML(currentZonesUrl()));
      if (!cartStyleInjected) {
        const style = document.createElement('style');
        style.textContent = `
          #delivery-checker-root-cart{display:grid;gap:.5rem;margin:.5rem 0 1rem 0}
          #delivery-checker-root-cart input{padding:.5rem;border:1px solid #ccc;border-radius:.375rem}
          #delivery-checker-root-cart button#pc-check-cart{padding:.5rem .75rem;border:1px solid #333;border-radius:.375rem;background:#111;color:#fff;cursor:pointer}
          #pc-result-cart ul{margin:.25rem 0 0 1rem}
          .pc-recalled{margin:.35rem 0 0;font-size:.85em;opacity:.75}
        `;
        anchor.appendChild(style);
        cartStyleInjected = true;
      }
      const root = anchor.querySelector('#delivery-checker-root-cart');
      if (root && !root._bound) {
        initInstance({
          root,
          input:      root.querySelector('#pc-input-cart'),
          button:     root.querySelector('#pc-check-cart'),
          out:        root.querySelector('#pc-result-cart'),
          suggestBox: root.querySelector('#pc-suggest-cart'),
          hintEl:     root.querySelector('.pc-hint')
        });
      }
    }
  }

  function attachCartDrawerObserver() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer._pcMoAttached) return;
    drawer._pcMoAttached = true;
    const mo = new MutationObserver(() => ensureCartDrawerInstance());
    mo.observe(drawer, { childList: true, subtree: true });
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.js-drawer-open-cart, [href="#CartDrawer"], [data-drawer="CartDrawer"], [aria-controls="CartDrawer"]');
      if (btn) {
        setTimeout(ensureCartDrawerInstance, 50);
        setTimeout(ensureCartDrawerInstance, 300);
        setTimeout(ensureCartDrawerInstance, 800);
      }
    });
    if (drawerRetryTimer) clearInterval(drawerRetryTimer);
    let attempts = 0;
    drawerRetryTimer = setInterval(() => {
      ensureCartDrawerInstance();
      if (++attempts > 30) clearInterval(drawerRetryTimer);
    }, 100);
  }

  function boot() {
    initDeliveryInfoPageIfPresent();
    ensureCartPageWidget();
    ensureCartDrawerInstance();
    attachCartDrawerObserver();
    bindCartPageCheckoutBtn();
    // Warm both files up front so the first keystroke already has the suburb list and
    // the first confirmed suburb already has its run dates. Cheap: one cached fetch each.
    try { loadZones().catch(()=>{}); } catch(_) {}
    try { loadDeliveryDates(); } catch(_) {}
  }

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
